import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { SVG_MORE_HORIZONTAL } from '@getgo/chameleon-icons';
import { NavigationRailHeightOverflowObserver } from '../Observers/FastElementHeightOverflowObserver';
const NOT_STICKY_ITEM_SELECTOR = 'chameleon-navigation-rail-item:not([sticky]), chameleon-navigation-rail-link:not([sticky])';
const ITEM_SELECTOR = 'chameleon-navigation-rail-item, chameleon-navigation-rail-link, chameleon-internal-navigation-rail-item';
const MORE_ITEM_HEIGHT = 80;
const MIN_SEPARATOR_HEIGHT = 20;
export class NavigationRailComponent extends NavigationRailHeightOverflowObserver {
    constructor() {
        super(...arguments);
        this.moreLabel = 'More';
        this.size = 'medium';
        this.stickyItems = () => this.querySelectorAll('[sticky]');
        this.volatileItems = [];
        this.popoverElement = null;
        this.moreItemElement = null;
        this.createPopover = () => {
            var _a;
            this.popoverElement = document.createElement('chameleon-popover');
            this.popoverElement.setAttribute('role', 'menuitem');
            this.popoverElement.setAttribute('position', 'right-center');
            this.popoverElement.setAttribute('arrow', 'true');
            this.popoverElement.setAttribute('menu', 'true');
            this.popoverElement.innerHTML = `<chameleon-internal-navigation-rail-item size=${this.size} slot="trigger" aria-label="${this.moreLabel}">
        <chameleon-svg style="height:14px" slot="start">${SVG_MORE_HORIZONTAL}</chameleon-svg>
        ${this.moreLabel}
      </chameleon-internal-navigation-rail-item>
      <div slot="content">
        <chameleon-menu></chameleon-menu>
      </div>`;
            this.moreItemElement = this.popoverElement.querySelector('chameleon-internal-navigation-rail-item');
            (_a = this.moreItemElement) === null || _a === void 0 ? void 0 : _a.addEventListener('change', this.onMoreRailItemChange);
            return this.popoverElement;
        };
        this.createSeparator = () => {
            return document.createElement('chameleon-menu-separator');
        };
        this.onMoreRailItemChange = (event) => {
            var _a, _b, _c;
            event.preventDefault();
            if ((_a = this.popoverElement) === null || _a === void 0 ? void 0 : _a.isOpen) {
                (_b = this.popoverElement) === null || _b === void 0 ? void 0 : _b.close();
            }
            else {
                (_c = this.popoverElement) === null || _c === void 0 ? void 0 : _c.open();
            }
        };
    }
    sizeChanged(oldValue, newValue) {
        const items = Array.from(this.querySelectorAll(ITEM_SELECTOR));
        items.forEach((item) => {
            if (newValue === 'small') {
                item.setAttribute('size', 'small');
            }
            else if (newValue === 'large') {
                item.setAttribute('size', 'large');
            }
            else {
                item.removeAttribute('size');
            }
        });
    }
    connectedCallback() {
        super.connectedCallback();
        // This is a temporary fix. We have to set the --goto-icon-size variable
        // on the svg element explicitly, because in some cases the element cannot
        // read the property if it's set somewhere up the tree on the parent.
        for (const svg of this.querySelectorAll('chameleon-svg').values()) {
            svg.style.setProperty('--goto-icon-size', '24px');
        }
        this.observer.observe(this);
    }
    handleElementHeightOverflow(el) {
        var _a;
        this.resetVolatileItems();
        this.removePopover();
        this.removeSeparator();
        (_a = this.popoverElement) === null || _a === void 0 ? void 0 : _a.remove();
        const items = Array.from(this.querySelectorAll(NOT_STICKY_ITEM_SELECTOR));
        const stickyItems = Array.from(this.stickyItems());
        const stickiesHeight = stickyItems.reduce((acc, item) => acc + item.offsetHeight, 0);
        if (el === null || el === void 0 ? void 0 : el.clientHeight) {
            const itemsHeight = items.reduce((acc, item) => {
                return acc + item.offsetHeight;
            }, 0);
            const availableSpace = el.clientHeight - stickiesHeight - MIN_SEPARATOR_HEIGHT;
            if (itemsHeight > availableSpace) {
                const popover = this.createPopover();
                const popoverMenu = popover.querySelector('chameleon-menu');
                if (popoverMenu) {
                    let heightUsed = 0;
                    this.volatileItems = items.reduce((acc, item) => {
                        heightUsed += item.offsetHeight;
                        if (heightUsed > availableSpace - MORE_ITEM_HEIGHT) {
                            return [...acc, item];
                        }
                        return acc;
                    }, []);
                    this.volatileItems.forEach((item) => {
                        item.setAttribute('appearance', 'menuitem');
                        popoverMenu.appendChild(item);
                    });
                    popoverMenu.querySelectorAll('chameleon-svg').forEach((svg) => {
                        svg === null || svg === void 0 ? void 0 : svg.style.setProperty('goto-icon-size', '14px');
                        svg.addSvgDimensions();
                    });
                }
                this.appendChild(popover);
            }
            if (stickyItems.length) {
                this.append(this.createSeparator(), ...stickyItems);
            }
        }
    }
    resetVolatileItems() {
        if (this.volatileItems.length) {
            this.volatileItems.forEach((item) => {
                item.setAttribute('appearance', 'navrailitem');
                this.appendChild(item);
            });
            this === null || this === void 0 ? void 0 : this.querySelectorAll('chameleon-svg').forEach((svg) => {
                svg === null || svg === void 0 ? void 0 : svg.style.setProperty('goto-icon-size', '24px');
                svg.addSvgDimensions();
            });
        }
    }
    removePopover() {
        var _a, _b, _c;
        (_a = this.moreItemElement) === null || _a === void 0 ? void 0 : _a.removeEventListener('change', this.onMoreRailItemChange);
        (_b = this.popoverElement) === null || _b === void 0 ? void 0 : _b.blur();
        (_c = this.popoverElement) === null || _c === void 0 ? void 0 : _c.remove();
    }
    removeSeparator() {
        const separator = this.querySelector('chameleon-menu-separator');
        separator === null || separator === void 0 ? void 0 : separator.remove();
    }
}
__decorate([
    attr({ attribute: 'more-label' })
], NavigationRailComponent.prototype, "moreLabel", void 0);
__decorate([
    attr
], NavigationRailComponent.prototype, "size", void 0);
